/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import _ from 'lodash';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import { FormControlLabel, Checkbox, Button } from '@material-ui/core';

import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  getCheckBoxValue,
  selectionList,
  getQuarterValue,
  dispatchQuarterValue,
  dispatchErrorMsg,
  getAllTemplateType,
  getCommonDropdownList,
  getGCLData,
  dispatchGCLData,
  dispatchGCLDetailPageData,
  dispatchSaveGCLData,
  dispatcPriorQtrData,
  dispatchGCLDetailList,
} from '../store/actions';
import {
  radioGroupPaymentGenerate,
  checkBoxPriorQtrUra,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  handleQuarterFormate,
  checkQuarterValidation,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';

const GenerateCollectionLetter = (props) => {
  const dispatch = useDispatch();

  // store collections
  const planTypeList = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.planType
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const getSelectionList = useSelector(
    (state) => state.sharedState.GeneratecdReducer.selection_list
  );
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.getErrorsFromGCL
  );
  const getQuarterDataValue = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.quarter
  );
  const AllTemplateType = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.TemplateType
  );
  const getAllGclData = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.getGCLData
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const statusBit = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.statusBit
  );

  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));
  // local state declaration
  // const [radioList, setRadioList] = useState([]);
  // const [rebateProgramList, setRebateProgramList] = useState([]);

  const setPaymentListOptions = [
    { name: 'No Payment Received', value: '1' },
    { name: 'No Payment Received and Amount Owed >0', value: '2' },
    { name: 'Percent Paid <', value: '3' },
    { name: 'Amount Owed >', value: '4' },
    { name: 'Not Paid in Full', value: '5' },
  ];
  const [state, setState] = useState(getSelectionList);
  const [rebateProList, setRebateProList] = React.useState([]);
  const [loading, setLoading] = useState(false);

  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    dispatch(
      dispatchErrorMsg({
        ...getErrorMsg,
        ...val,
      })
    );
  };

  // set common dropdown list
  React.useEffect(() => {
    if (state?.planTypeCd) {
      getCommonDropdownList(state?.planTypeCd).then((res) =>
        setRebateProList(res)
      );
    }
  }, [state?.planTypeCd]);

  // Template calling data
  const fetchAllTemplateList = (val) => {
    dispatch(
      getAllTemplateType({
        rebateProgramCd: val,
        templateTypeCd: ['COLLECT'],
      })
    );
  };

  // This Run when isRefresh is true
  React.useEffect(() => {
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter(
        (x) => x.navTo === '/GenerateCollectionLetter' && x.isRefresh
      ).length > 0
    ) {
      // setLoading(true);
      dispatch(
        getCheckBoxValue({
          codeDomainList: ['PLAN_TYPE_CD'],
        })
      );
      const searchVal = {};
      searchVal.planTypeCd = 'FD';
      searchVal.rebateProgramCd = '-1';
      searchVal.paymentStatus = '1';
      searchVal.quarter = '';
      searchVal.percentPaid = null;
      searchVal.amountOwed = null;
      searchVal.templateName = '-1';
      searchVal.daysInvoiceDistributed = 0;
      searchVal.uraChecked = true;
      searchVal.selectedTemplate = {};
      if (userDefaults && !_.isEmpty(userDefaults)) {
        searchVal.planTypeCd = userDefaults.planTypeCd
          ? userDefaults.planTypeCd
          : 'FD';
        searchVal.rebateProgramCd = userDefaults.rebateProgramCd
          ? userDefaults.rebateProgramCd
          : '-1';
      }
      if (searchVal.rebateProgramCd && searchVal.rebateProgramCd !== '-1') {
        fetchAllTemplateList(searchVal.rebateProgramCd);
        dispatch(
          getQuarterValue({ rebateProgramCd: searchVal.rebateProgramCd })
        );
      }
      // fetchRebateProgram(searchVal.planTypeCd);
      setState({ ...searchVal });
      dispatch(selectionList({ ...searchVal }));
      setErrorStateChange({ searchScreenErrors: [] });
      const newObj = localStore.map((item) => {
        if (item.navTo === '/GenerateCollectionLetter' && item.isRefresh) {
          item.isRefresh = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [userDefaults, localStore]);

  // tab highlighter function
  React.useEffect(() => {
    if (
      getErrorMsg?.searchScreenErrors &&
      getErrorMsg?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/GenerateCollectionLetter', true);
    } else {
      tabHighLigther('/GenerateCollectionLetter', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // get rebate program dropdown data
  const rebateProgramList = React.useMemo(() => {
    let list = [];
    if (!_.isEmpty(rebateProList)) {
      list = _.map(rebateProList, (val) => ({
        ...val,
        id: val.rebateProgramCd,
        name: `${val.rebateProgramCd} | ${val.shortDescr}`,
      }));
      list = _.orderBy(list, ['name'], ['asc']);
    }
    return list;
  }, [rebateProList]);

  // get all qtr value and save in state
  React.useEffect(() => {
    if (getQuarterDataValue) {
      // if (!state.quarter || state.quarter === '') {
      setState({ ...state, quarter: getQuarterDataValue });
      dispatch(selectionList({ ...state, quarter: getQuarterDataValue }));
      dispatch(dispatchQuarterValue(''));
      // }
    }
  }, [getQuarterDataValue]);

  // set up plan type radio button data
  const radioList = React.useMemo(() => {
    let planList = [];
    if (!_.isEmpty(planTypeList)) {
      planList = planTypeList.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      planList = [
        ..._.filter(planList, (l) => l.value === 'FD'),
        ..._.filter(planList, (l) => l.value !== 'FD'),
      ];
    }
    return planList;
  }, [planTypeList]);

  // get all template list
  const templateNameListSet = React.useMemo(() => {
    let list = [];
    if (!_.isEmpty(AllTemplateType)) {
      list = !_.isEmpty(AllTemplateType.letterTemplate)
        ? _.map(AllTemplateType.letterTemplate, (val) => ({
            id: val.templateId,
            name: val.name,
            tempversion: val.templateVersion,
          }))
        : [];
    }
    list = _.union(list);
    list = _.orderBy(list, ['name'], ['asc']);
    return list;
  }, [AllTemplateType]);

  // handle all field onchange action
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg?.searchScreenErrors;
    if (
      !_.isEmpty(localErr) &&
      _.includes(['rebateProgramCd', 'templateName'], name)
    ) {
      localErr = localErr.filter((item) => !_.includes([name], item?.field));
    }
    const newState = { ...state };
    newState[name] = value;
    if (name === 'paymentStatus') {
      newState.percentPaid = '';
      newState.amountOwed = '';
      localErr = !_.isEmpty(localErr)
        ? localErr.filter(
            (item) =>
              item.field !== 'percentPaid' && item.field !== 'amountOwed'
          )
        : localErr;
    }
    if (name === 'rebateProgramCd') {
      newState.templateName = '-1';
      newState.selectedTemplate = {};
      if (newState.rebateProgramCd && newState.rebateProgramCd !== '-1') {
        newState.quarter = '';
        fetchAllTemplateList(newState.rebateProgramCd);
        dispatch(
          getQuarterValue({ rebateProgramCd: newState.rebateProgramCd })
        );
      }
    }
    if (name === 'planTypeCd') {
      newState.templateName = '-1';
      newState.selectedTemplate = {};
      newState.rebateProgramCd = '-1';
      // fetchRebateProgram(value);
    }
    if (name === 'templateName') {
      const selectedList = _.filter(
        AllTemplateType.letterTemplate,
        (l) => l.templateId === value
      );
      newState.selectedTemplate = !_.isEmpty(selectedList)
        ? selectedList[0]
        : {};
    }
    setState(newState);
    dispatch(selectionList(newState));
    setErrorStateChange({ searchScreenErrors: [...new Set(localErr)] });
  };
  // on blur functionality for fields
  const handleOnBlurEvent = (type, value) => {
    let localErr = getErrorMsg?.searchScreenErrors
      ? getErrorMsg?.searchScreenErrors
      : [];

    if (!_.isEmpty(localErr)) {
      localErr = localErr.filter((item) => !_.includes([type], item?.field));
    }
    const newState = { ...state };
    newState[type] = value;

    if (type === 'quarter') {
      let msg = '';
      let errorType = '';
      if (!value && !_.isEmpty(value) && !_.isNaN(value)) {
        msg = constantMessageData.QUARTER_VALUE_REQUIRED;
        errorType = 'Quarter Required';
      } else if (!checkQuarterValidation(value)) {
        msg = constantMessageData.VALIDATE_QUARTER_VALUE;
        errorType = 'Quarter invalid';
      } else {
        newState[type] = autoFormateDate(value?.toUpperCase());
      }
      if (msg) {
        localErr.push({
          field: type,
          errorType: errorType,
          message: msg,
        });
      }
    }

    if (type === 'amountOwed') {
      if (!value && value === '') {
        localErr.push({
          field: type,
          errorType: 'AMOUNT_OWED_REQUIRED',
          message: constantMessageData.AMOUNT_OWED_REQUIRED,
        });
      }
    }

    if (type === 'percentPaid') {
      if (!value && value === '') {
        localErr.push({
          field: type,
          errorType: 'PERCENT_PAID_REQUIRED',
          message: constantMessageData.PERCENT_PAID_REQUIRED,
        });
      } else {
        // const rg = /^([0-9]*[.])?[0-9]+$/;
        // if (rg.test(value)) {
        newState[type] = parseFloat(value);
        // }
      }
    }

    setState(newState);
    dispatch(selectionList(newState));
    setErrorStateChange({ searchScreenErrors: [...new Set(localErr)] });
  };

  // get individualy all field error
  const getFieldError = (key) => {
    if (
      !_.isEmpty(getErrorMsg?.searchScreenErrors) &&
      getErrorMsg?.searchScreenErrors?.length > 0
    ) {
      const filterErr = _.filter(
        getErrorMsg?.searchScreenErrors,
        (l) => l.field === key
      );
      if (!_.isEmpty(filterErr)) {
        return _.map(filterErr, (m) => m.message);
      }
    }
    return null;
  };

  // check value in proper format
  const checkValueRegx = (flType, val) => {
    let pass = false;
    let withDecimal = /^[0-9.]*$/;
    let withoutDecimal = /^[0-9.]*$/;
    if (flType === 'amountOwed') {
      withDecimal = /^[0-9]{0,9}(\.[0-9]{0,2})?$/;
      withoutDecimal = /^[0-9]{0,9}?$/;
    }
    if (flType === 'percentPaid') {
      withDecimal = /^[0-9]{0,5}(\.[0-9]{0,6})?$/;
      withoutDecimal = /^[0-9]{0,5}?$/;
    }
    if (val && val.includes('.')) {
      const rx = withDecimal;
      if (rx.test(val)) {
        pass = true;
      }
    } else {
      const rx_without = withoutDecimal;
      if (rx_without.test(val)) {
        pass = true;
      }
    }
    return pass;
  };

  // moving to detail screen
  const moveToDetails = () => {
    setLoading(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/Collectionletterdetail',
      value: 'Generate Collection Letter Detail',
      isFormDirty: false,
      isFormError: false,
      isFormSave: false,
      isRefresh: true,
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/Collectionletterdetail',
    });
  };

  const getProperData = (value, data) => {
    let arr = _.map(data, (item, i) => {
      if (item.sentDt === null) {
        item.sendFlag = true;
        item.notNeededFlag = false;
      }
      return item;
    });
    if (!value?.includeAlreadySent && !_.isEmpty(arr)) {
      arr = _.filter(arr, (l) => !l.sentDt);
    }
    return arr;
  };

  // get before redirect detail page GCL Data
  React.useEffect(() => {
    const localErr = [];
    if (!_.isEmpty(getAllGclData)) {
      let showError = false;
      if (
        getAllGclData?.message === 'SUCESS' &&
        getAllGclData?.status === '001'
      ) {
        if (!_.isEmpty(getAllGclData?.gclVO)) {
          const newGCLData = _.cloneDeep(getAllGclData?.gclVO);

          if (!_.isEmpty(newGCLData?.generateCollectionLetterListVO)) {
            let cglListVO = _.map(
              newGCLData.generateCollectionLetterListVO,
              (item) => {
                if ('sendFlag' in item) {
                  return item;
                }
                // item.sendFlag = true;
                const hasSentDate = !!item.sentDt;
                item.sendFlag = !hasSentDate;
                item.notNeededFlag = false;
                item.freeFormText = item.freeFormText ? item.freeFormText : '';
                item.letterId = item.letterId ? item.letterId : null;
                return item;
              }
            );
            // newGCLData.generateCollectionLetterListVO = cglListVO;
            const newState = {
              ..._.cloneDeep(state),
              includeAlreadySent: false,
              fullScreenView: false,
            };

            cglListVO = getProperData(newState, cglListVO);

            const newData = {
              serachData: newState,
              detailData: newGCLData,
            };
            dispatch(dispatchGCLData([]));
            dispatch(dispatchGCLDetailPageData(newData));
            dispatch(dispatchGCLDetailList(cglListVO));
            dispatch(dispatchSaveGCLData([]));
            moveToDetails();
          } else {
            showError = true;
          }
        } else {
          showError = true;
        }
      } else {
        showError = true;
      }
      if (showError) {
        setLoading(false);
        localErr.push({
          field: 'search',
          errorType: 'noResults',
          message: constantMessageData.MNFC_NDC_ERROR_MSG,
        });

        setErrorStateChange({ searchScreenErrors: [...new Set(localErr)] });
      }
    }
  }, [getAllGclData]);

  // on click search button action for go to detail page
  const callSearchData = () => {
    const localErr = [];
    // if (!_.isEmpty(localErr)) {
    //   localErr = localErr.filter((item) => !_.includes(['rebateProgramCd', 'quarterFormat', 'templateName', 'percentPaid', 'amountOwed', 'daysInvoiceDistributed'], item.field));
    // }

    if (!state.rebateProgramCd || state.rebateProgramCd === '-1') {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED_REQ,
      });
    }

    if (!state.templateName || state.templateName === '-1') {
      localErr.push({
        field: 'templateName',
        errorType: 'templateRequired',
        message: constantMessageData.TEMPLATE_REQUIRED,
      });
    }

    if (!state.quarter || state.quarter === '' || state.quarter === null) {
      localErr.push({
        field: 'quarter',
        errorType: 'quarterRequired',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    }

    if (
      state.paymentStatus === '3' &&
      (!state.percentPaid || state.percentPaid === '')
    ) {
      localErr.push({
        field: 'percentPaid',
        errorType: 'required',
        message: constantMessageData.PERCENT_PAID_REQUIRED,
      });
    }
    if (
      state.paymentStatus === '4' &&
      (!state.amountOwed || state.amountOwed === '')
    ) {
      localErr.push({
        field: 'amountOwed',
        errorType: 'required',
        message: constantMessageData.AMOUNT_OWED_REQUIRED,
      });
    }

   if (
    state.daysInvoiceDistributed === undefined ||
    state.daysInvoiceDistributed === null ||
    state.daysInvoiceDistributed === ''
    ) {
    localErr.push({
    field: 'daysInvoiceDistributed',
    errorType: 'daysInvoiceDistributedRequired',
    message: constantMessageData.DAYS_SINCE_INVOICE,
    });
  }

    if (!_.isEmpty(localErr)) {
      setErrorStateChange({ searchScreenErrors: [...new Set(localErr)] });
      window.scrollTo(0, 0);
    } else {
      setErrorStateChange({ searchScreenErrors: [] });
      const parsedDays = parseInt(state.daysInvoiceDistributed, 10);
      const payload = {
        qtr: state.quarter,
        rpc: state.rebateProgramCd,
        uraChecked: state.uraChecked,
        daysSinceInvoiceDistributed :
        state.daysInvoiceDistributed != null && !isNaN(parsedDays)
        ? parsedDays
        : null,
        paymentStatus: parseInt(state.paymentStatus, [0, 10000]),
      };

      if (state.paymentStatus === '3') {
        payload.percentPaid = state.percentPaid;
      }
      if (state.paymentStatus === '4') {
        payload.amountOwed = Number(state.amountOwed);
      }
      if (state && !_.isEmpty(state.selectedTemplate)) {
        payload.templateId = state.selectedTemplate.templateId;
        payload.templateVersion = state.selectedTemplate.templateVersion;
        // dispatch(selectionList(state));
        setLoading(true);
        dispatch(getGCLData(payload));
      }
    }
    dispatch(dispatcPriorQtrData(state.uraChecked));
  };

  return (
    <div className="tabs-container" data-testid="generateCollectionLetter">
      <CustomSeparator parent1="Tasks" parent2="Generate Collection Letters" />

      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            getErrorMsg?.searchScreenErrors?.length > 0
              ? _.map(getErrorMsg.searchScreenErrors, (l) => l.message)
              : []
          ),
        ]}
      />
      <Spinner load={spinnerLoader || loading} />
      <div className="clearfix" />
      <div className="no-margin">
        <div className="panel mb-3">
          <div className="row d-flex align-items-center mb-4">
            <div className="col-12 col-sm-12 col-md-6 frr-checkInvoiceRadio frr-two-col-radio">
              <RadioGroupComponent
                data-testid="filter-plan-by-radio-btn"
                id="filter-plan-by-radio-btn-action"
                labelName="Plan Type"
                required
                optionList={radioList}
                defaultValue={state && state.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
              />
            </div>

            <div className="col-12 col-sm-12 col-md-6 mt-sm-2 mt-md-0">
              <div className="row">
                <div className="col-12 mt-2 mt-sm-0 col-sm-6 col-md-6 frr-radio-100per-width">
                  <SelectBoxWithoutBoxComponent
                    data-testid="rebate_program-ia"
                    className="mt-2"
                    labelName="Rebate Program:"
                    required
                    select
                    selectedOne
                    placeholder="Please Select One"
                    optionList={rebateProgramList || []}
                    defaultValue={state && state?.rebateProgramCd}
                    filterAction={(e) =>
                      handleOnChangeEvent(e, 'rebateProgramCd')
                    }
                    isError={getFieldError('rebateProgramCd')}
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-6 frr-radio-100per-width">
                  <SelectBoxWithoutBoxComponent
                    data-testid="Quarter-ia"
                    className="mt-2"
                    labelName="Quarter:"
                    required
                    select={false}
                    // placeholder="Quarter #Q## or #Q####"
                    defaultValue={state && state?.quarter}
                    filterAction={(e) => handleOnChangeEvent(e, 'quarter')}
                    onBlurAction={(e) => handleOnBlurEvent('quarter', e)}
                    isError={getFieldError('quarter')}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-sm-12 col-md-8 mt-2">
              <fieldset
                data-testid="radio-box-component"
                className="radioBtnGroup custom-fieldset h-100"
              >
                <legend className="same-font-family">
                  {radioGroupPaymentGenerate}{' '}
                  <span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper db">
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup
                        row
                        name="paymentStatus"
                        defaultValue={state && state.paymentStatus}
                        value={state && state.paymentStatus}
                        data-testid="payment-radio-box-group-control"
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'paymentStatus')
                        }
                      >
                        {!_.isEmpty(setPaymentListOptions)
                          ? setPaymentListOptions.map((v, i) => (
                              <FormControlLabel
                                value={v.value}
                                control={<Radio />}
                                label={v.name}
                                key={v.value && _.kebabCase(v.value)}
                              />
                            ))
                          : null}
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="row custom-search-dates">
                  <div className="col-12 col-sm-6 col-md-4 frr-radio-100per-width">
                    <SelectBoxWithoutBoxComponent
                      data-testid="percentPaid-ia"
                      labelName="percentPaid-ia"
                      className="frr-display-hidden-label"
                      select={false}
                      id="percentPaid-ia"
                      disabled={state.paymentStatus !== '3'}
                      inputProps={{
                        maxLength: 12,
                        id: 'percentPaid-ia',
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            className="frr-percent-right-padding"
                            position="end"
                          >
                            %
                          </InputAdornment>
                        ),
                      }}
                      defaultValue={state && state?.percentPaid}
                      filterAction={(e) => {
                        // const rg = /^[0-9.]*$/;
                        const checkVal = checkValueRegx('percentPaid', e);
                        if (checkVal) {
                          handleOnChangeEvent(e, 'percentPaid');
                        }
                      }}
                      onBlurAction={(e) => {
                        // const rg = /^[0-9.]*$/;
                        const checkVal = checkValueRegx('percentPaid', e);
                        if (checkVal) {
                          handleOnBlurEvent('percentPaid', e);
                        }
                      }}
                      isError={getFieldError('percentPaid')}
                    />
                  </div>

                  <div className="col-12 col-sm-6 col-md-4 frr-radio-100per-width">
                    <SelectBoxWithoutBoxComponent
                      data-testid="amountOwed-ia"
                      labelName="amountOwed-ia"
                      id="amountOwed-ia"
                      className="frr-display-hidden-label"
                      select={false}
                      disabled={state.paymentStatus !== '4'}
                      inputProps={{ maxLength: 14, id: 'amountOwed-ia' }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                        startAdornment: (
                          <InputAdornment
                            className="frr-dollar-left-padding"
                            position="start"
                          >
                            $
                          </InputAdornment>
                        ),
                      }}
                      defaultValue={state && state?.amountOwed}
                      filterAction={(e) => {
                        // const rg = /^[0-9.]*$/;
                        const checkVal = checkValueRegx('amountOwed', e);
                        if (checkVal) {
                          handleOnChangeEvent(e, 'amountOwed');
                        }
                      }}
                      onBlurAction={(e) => {
                        // const rg = /^[0-9.]*$/;
                        const checkVal = checkValueRegx('amountOwed', e);
                        if (checkVal) {
                          handleOnBlurEvent('amountOwed', e);
                        }
                      }}
                      isError={getFieldError('amountOwed')}
                    />
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-12 col-sm-12 col-md-4 mt-2 frr-radio-100per-width">
              <SelectBoxWithoutBoxComponent
                data-testid="template-name-ia"
                className="mt-2"
                labelName="Template Name:"
                required
                select
                selectedOne
                placeholder="Please Select One"
                optionList={templateNameListSet || []}
                defaultValue={state && state?.templateName}
                filterAction={(e) => handleOnChangeEvent(e, 'templateName')}
                isError={getFieldError('templateName')}
              />

              <SelectBoxWithoutBoxComponent
                data-testid="daysInvoiceDistributed-ia"
                className="mt-4"
                labelName="Days Since Invoice Distributed >"
                required
                select={false}
                inputProps={{ maxLength: 4 }}
                defaultValue={state && state?.daysInvoiceDistributed}
                filterAction={(e) => {
                  const rg = /^[0-9]*$/;
                  if (rg.test(e)) {
                    handleOnChangeEvent(e, 'daysInvoiceDistributed');
                  }
                }}
                onBlurAction={(e) => {
                  const rg = /^[0-9]*$/;
                  if (rg.test(e)) {
                    handleOnBlurEvent('daysInvoiceDistributed', e);
                  }
                }}
                isError={getFieldError('daysInvoiceDistributed')}
              />
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-8 pl-4">
              <FormControlLabel
                data-testid="checked_ia"
                control={<Checkbox color="primary" className="" />}
                label={checkBoxPriorQtrUra}
                value={state && state.uraChecked}
                checked={state && state.uraChecked}
                onChange={(e) =>
                  handleOnChangeEvent(e.target.checked, 'uraChecked')
                }
              />
            </div>

            <div className="col-4 align-item-right">
              <Button
                className="btn btn-success btn-search"
                style={{ textTransform: 'none' }}
                data-testid="search"
                type="button"
                onClick={callSearchData}
              >
                <SVGComponent iconName="Icon-search" />
                {'  '} Search
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateCollectionLetter;
